<div class="loaderwrapper" *ngIf="this.loader">
    <span class="loader"></span>
</div>
<!-- <pre>{{selectedPlant |json}}</pre> -->
<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <!-- <div class="row mb-4 block-topbar">
            <div class="col-12 d-sm-flex align-items-center justify-content-between">
                <div class="breadcrumb-main inner">
                    <ul class="breadcrumb">
                        <li>Plants</li>
                        <li><a [routerLink]="['/plants']" (click)="showPlantList()">Plant List</a></li>
                        <li class="skip-arrow">Cluster</li>
                    </ul>
                </div>
            </div>
        </div> -->
        <div class="pg-header">
            <div class="pg-header__crumbs">
                <h1 class="pg-title pg-title--with-back">
                    <button type="button" class="pg-back" (click)="showPlantList()" title="Back to Plants"
                        aria-label="Back to Plants">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M15.5 12H9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.5 15L8.5 12L11.5 9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                    Cluster
                </h1>
            </div>
            <!-- Action Buttons -->
            <!-- <div class="pg-header__actions">
                        <button type="button" class="btn btn-outline-dark" (click)="showPlantList()">
                            Back to Plants
                        </button>
                    </div> -->
        </div>
        <div class="card table-card">
            <div class="table-wrap">
                <div class="table-main">
                    <div>
                        <table class="table-data text-center">
                            <thead>
                                <tr>
                                    <th class="text-start">Plant Name</th>
                                    <th class="text-center">Contract Type</th>
                                    <th class="text-center">Region</th>
                                    <th class="text-center">City</th>
                                    <th class="text-center">Address</th>
                                    <th class="text-center">Specific Yield (KWh/KWP)</th>
                                    <th class="text-center">Specific Yield Yesterday</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-start">{{selectedPlant?.plantName}}</td>
                                    <td>{{selectedPlant?.contract_type_name}}</td>
                                    <td>{{selectedPlant?.region_name}}</td>
                                    <td>{{selectedPlant?.city_name}}</td>
                                    <td>{{selectedPlant?.plantAddress}}</td>
                                    <td>{{selectedPlant?.specificYield}}</td>
                                    <td>{{selectedPlant?.specificYieldYesterday}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="card table-card w-100 mt-4">
        <div class="table-wrap">
            <div class="table-main">
                <div>
                    <table class="table-data text-center">
                        <ng-container *ngIf="movedStations && movedStations.length>0">
                            <thead class="thead-gray">
                                <tr>
                                    <th scope="col">Station Name</th>
                                    <th scope="col">Wind Speed</th>
                                    <th scope="col">Temprature</th>
                                    <th scope="col">Radiant Line</th>
                                    <th scope="col">Radiant Total</th>
                                    <th scope="col">PV Temprature</th>
                                    <th scope="col">Horizontal Radiant Line</th>
                                    <th scope="col">Horizontal Radiant Total</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                        </ng-container>
                        <tbody>
                            <ng-container *ngIf="movedStations && movedStations.length>0">
                                <tr *ngFor="let row of movedStations">
                                    <td>{{row.stationName || '---'}}</td>
                                    <td>{{row.wind_speed || '---'}}</td>
                                    <td>{{row.dataItemMap['temperature'] || '---'}}</td>
                                    <td>{{row.dataItemMap['radiant_line']|| '---'}}</td>
                                    <td>{{row.dataItemMap['radiant_total']|| '---'}}</td>
                                    <td>{{row.dataItemMap['pv_temperature']|| '---'}}</td>
                                    <td>{{row.dataItemMap['horiz_radiant_line']|| '---'}}</td>
                                    <td>{{row.dataItemMap['horiz_radiant_total']|| '---'}}</td>
                                    <td>
                                        <div class="btn btn-outline-danger btn-rounded"
                                            (click)="removeFromMovedStations(row.devId)">Remove</div>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr>
                                <td colspan="100%">
                                    <div
                                        class="col-12 block-topbar d-sm-flex align-items-center justify-content-between p-0 my-4">
                                        <div>
                                            <div class="d-flex align-items-center gap-3">
                                                <span>Radius (Km)</span>
                                                <div class="custom-number-wrapper">
                                                    <input type="number" class="form-control" step="10" min="1"
                                                        max="500" [(ngModel)]="clusterValue" name="clusterRadius"
                                                        (keypress)="allowOnlyNumbers($event)"
                                                        (paste)="blockInvalidPaste($event)" />
                                                    <div class="custom-arrows svg-arrows">
                                                        <div class="arrow-btn arrow-up" (click)="incrementRadius()">
                                                        </div>
                                                        <div class="arrow-btn arrow-down" (click)="decrementRadius()">
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn-dark btn-rounded"
                                                    (click)="onShowCluster()"
                                                    [disabled]="clusterValue <= 0 || clusterValue > 500">
                                                    Show Cluster
                                                </button>
                                            </div>
                                            <span class="text-danger mt-1 text-start"
                                                *ngIf="clusterValue <= 0 || clusterValue > 500">Radius must be
                                                between 1
                                                and 500 Km</span>
                                        </div>

                                        <!-- <div class="d-flex align-items-center gap-3">
                                            <span>Radius (Km)</span>
                                            <div class="custom-number-wrapper">
                                                <input type="number" class="form-control" step="10" min="10" max="500"
                                                    [value]="10" #clusterRadius
                                                    (input)="enforceLimits(clusterRadius)" />
                                                <div class="custom-arrows svg-arrows">
                                                    <div class="arrow-btn arrow-up" (click)="increment(clusterRadius)">
                                                    </div>
                                                    <div class="arrow-btn arrow-down"
                                                        (click)="decrement(clusterRadius)"></div>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-secondary-orange btn-rounded"
                                                (click)="getTableData()">
                                                Show Cluster
                                            </button>
                                        </div> -->
                                        <div class="d-flex justify-content-end">
                                            <button type="button" (click)="openModal(content)"
                                                class="btn btn-dark btn-rounded">
                                                Nearest EMI
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
            <div class="datatable-container position-relative">
                <div class="loaderwrapper" *ngIf="isLoadingTable">
                    <span class="loader"></span>
                </div>

                <!-- (activate)="onActivate($event,ticketDetail)" -->
                <ngx-datatable #myTable [style.width]="'100%'" class="material expandable table-responsive table-full"
                    [rows]="clusterPlants" [headerHeight]="50" [footerHeight]="0" [columnMode]="'force'"
                    [scrollbarH]="true" [rowHeight]="'auto'" [offset]="0" [externalSorting]="true"
                    [messages]="{emptyMessage: 'No data found.'}" (sort)="onSort($event)">

                    <ngx-datatable-column [sortable]="false" name="Sr. No." prop="id" [width]="80" [maxWidth]="80">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.id">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{ row.srNo }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Status" prop="id" [width]="80" [maxWidth]="80">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.id">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span *ngIf="row.status === 'Online'" class="status-circle-online flex-shrink-0"
                                title="Online"></span>
                            <span *ngIf="row.status === 'Offline'" class="status-circle-offline flex-shrink-0"
                                title="Offline"></span>
                            <span *ngIf="row.status === 'Faulty'" class="status-circle-faulty flex-shrink-0"
                                title="Faulty"></span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Plant Name" prop="id">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.stationCode">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{row.plantName}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Plant Type" prop="id">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.id">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{row.type}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Capacity (KWP)" prop="capacity">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('capacity')">
                                Capacity (KWP)
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'capacity',
                                      'datatable-icon-up': sortColumn === 'capacity' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'capacity' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px">
                                <span>{{row.capacity}}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Current Power (KW)" prop="currentPower">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('currentPower')">
                                Current Power (KW)
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'currentPower',
                                      'datatable-icon-up': sortColumn === 'currentPower' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'currentPower' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px">
                                <span>{{ row.currentPower }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Specific Yield (KWh/KWP)" prop="specificYield">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('specificYield')">
                                Specific Yield (KWh/KWP)
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'specificYield',
                                      'datatable-icon-up': sortColumn === 'specificYield' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'specificYield' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px">
                                <span>{{ row.specificYield }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Specific Yield Yesterday"
                        prop="specificYieldYesterday">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('specificYieldYesterday')">
                                Specific Yield Yesterday
                                <span class="sort-btn"
                                    [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'specificYieldYesterday',
                                      'datatable-icon-up': sortColumn === 'specificYieldYesterday' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'specificYieldYesterday' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px">
                                <span>{{ row.specificYieldYesterday }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Yesterday Generation (KWh)" prop="energyYesterday">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.energyYesterday">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{ row.energyYesterday }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Todays Generation (KWh)" prop="energyToday">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.energyToday">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{ row.energyToday }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
                <div class="table-meta">
                    <div class="entries">
                        <span>Total Records: {{this.total_items }}</span>
                    </div>
                    <nav class="table-pagination">
                        <ul>
                            <li>
                                <div class="go-to-page d-flex align-items-center">
                                    <label>Go to Page:</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                        min="1" [max]="total_pages"
                                        (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                    <div class="input-group-append">
                                        <button class="btn btn-primary" type="button"
                                            (click)="goToPage(pageToGo); pageToGo = null"
                                            [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                    </div>
                                </div>
                            </li>
                            <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                    [class.disabled]="current_page === 1">1</a></li>
                            <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                        class="fa fa-chevron-left"></i></a></li>
                            <li><a class="active">{{ current_page }}</a></li>
                            <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                    [class.disabled]="current_page === total_pages"><i
                                        class="fa fa-chevron-right"></i></a>
                            </li>
                            <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                    [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #content let-modal let-c="close" let-d="dismiss" let-width="1778">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Nearest EMI</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');resetSelection()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <div class="modal-body">
        <div class="col-12 block-topbar d-sm-flex align-items-center justify-content-between p-0 my-4">
            <div>
                <div class="d-flex align-items-center gap-3">
                    <span>Radius (Km)</span>
                    <div class="custom-number-wrapper">
                        <input type="number" class="form-control" step="10" min="1" max="500" [(ngModel)]="emiValue"
                            name="emiRadius" (keypress)="allowOnlyNumbers($event)"
                            (paste)="blockInvalidPaste($event)" />
                        <div class="custom-arrows svg-arrows">
                            <div class="arrow-btn arrow-up" (click)="incrementEmi()"></div>
                            <div class="arrow-btn arrow-down" (click)="decrementEmi()"></div>
                        </div>
                    </div>
                    <button type="button" class="btn btn-dark btn-rounded" (click)="getEmiStations(emiValue)"
                        [disabled]="emiValue <= 0 || emiValue > 500">
                        Fetch EMI Stations
                    </button>
                </div>
                <span class="text-danger mt-1" *ngIf="emiValue <= 0 || emiValue > 500">Radius must be between 1 and 500
                    Km</span>
            </div>
            <!-- <div class="d-flex align-items-center gap-3">
                <span>Radius (Km)</span>
                <div class="custom-number-wrapper">
                    <input type="number" class="form-control" step="10" min="10" max="500" [value]="10" #emiRadius
                        (input)="enforceLimits(emiRadius)" />
                    <div class="custom-arrows svg-arrows">
                        <div class="arrow-btn arrow-up" (click)="increment(emiRadius)">
                        </div>
                        <div class="arrow-btn arrow-down" (click)="decrement(emiRadius)"></div>
                    </div>
                </div>
                <button type="button" class="btn btn-secondary-orange btn-rounded" (click)="getEmiStations(emiRadius)">
                    Fetch EMI Stations
                </button>
            </div> -->
        </div>
        <div class="table-edge">
            <div class="table-responsive">
                <table class="table text-center">
                    <thead class="thead-gray">
                        <tr>
                            <th scope="col" style="width: 2%;"><span class="invisible opcaity-0">checkbox</span></th>
                            <th scope="col">Plants</th>
                            <th scope="col">Wind Speed</th>
                            <th scope="col">Temprature</th>
                            <th scope="col">Radiant Line</th>
                            <th scope="col">Radiant Total</th>
                            <th scope="col">PV Temprature</th>
                            <th scope="col">Horizontal Radiant Line</th>
                            <th scope="col">Horizontal Radiant Total</th>
                            <th scope="col">Packet Received</th>
                            <th scope="col">Distance (KM)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!isLoadingTableInner; else LoadingRow">
                            <ng-container *ngIf="emiPlants && emiPlants.length>0 else noRow">
                                <tr *ngFor="let row of emiPlants">
                                    <td>
                                        <label class="custom-checkbox med" *ngIf="!isMoved(row.devId)">
                                            <input class="checkbox-item m-0" type="checkbox"
                                                [checked]="checkedMap[row.devId] || isMoved(row.devId)"
                                                (change)="onCheckboxChange($event, row)"
                                                [disabled]="isMoved(row.devId)">
                                            <span class="checkbox-item m-0"></span>
                                        </label>
                                        <button class="btn btn-link text-danger p-0" *ngIf="isMoved(row.devId)"
                                            (click)="removeFromMovedStations(row.devId)" data-bs-toggle="tooltip"
                                            data-bs-trigger="hover" data-bs-placement="top" title="Remove Station">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <rect width="24" height="24" rx="12" fill="white" />
                                                <path d="M7 7.00002L12.0515 12.0515L17.103 7.00002"
                                                    stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M6.99995 17.6718L12.0505 12.6203L17.1021 17.6718"
                                                    stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                    </td>
                                    <td>{{row.stationName}}</td>
                                    <td>{{row.dataItemMap.wind_speed}}</td>
                                    <td>{{row.dataItemMap.temperature}}</td>
                                    <td>{{row.dataItemMap.radiant_line}}</td>
                                    <td>{{row.dataItemMap.radiant_total}}</td>
                                    <td>{{row.dataItemMap.pv_temperature}}</td>
                                    <td>{{row.dataItemMap.horiz_radiant_lin || 'Null'}}</td>
                                    <td>{{row.dataItemMap.horiz_radiant_total || 'Null'}}</td>
                                    <td>{{row.collectTime | date:'short'}}</td>
                                    <td>{{row.distanceKm}}KM away</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer no-bg">
        <!-- <button type="button" class="btn btn-orange" (click)="d('Cross click')" type="submit">
            Move Record
        </button> -->
        <button type="button" class="btn btn-orange" (click)="moveSelectedRecords(modal)">
            Move Record
        </button>

    </div>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="100%">
            <div class="fw-semibold text-center">
                No data found
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>